import { useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { LayoutDashboard, Receipt, BarChart3, Menu, Sparkles, X } from 'lucide-react';
import { Toaster } from '../components/ui/sonner';

const nav = [
  { to: '/', label: 'Panel', icon: LayoutDashboard, testId: 'nav-dashboard' },
  { to: '/islemler', label: 'İşlemler', icon: Receipt, testId: 'nav-transactions' },
  { to: '/raporlar', label: 'Raporlar', icon: BarChart3, testId: 'nav-reports' },
];

const Brand = () => (
  <div className="flex items-center justify-center px-6 py-6">
    <img
      src="/medieste.png"
      alt="Medi Este"
      className="h-16 w-auto object-contain"
      data-testid="brand-logo"
    />
  </div>
);

const NavItems = ({ onClick }) => {
  const loc = useLocation();
  return (
    <nav className="flex-1 px-3">
      {nav.map(({ to, label, icon: Icon, testId }) => {
        const active = loc.pathname === to || (to !== '/' && loc.pathname.startsWith(to));
        return (
          <NavLink
            key={to}
            to={to}
            onClick={onClick}
            data-testid={testId}
            className={`mb-1 flex items-center gap-3 rounded-xl px-4 py-3 text-sm transition-colors ${
              active
                ? 'bg-salon-secondary/60 text-salon-primary-hover font-medium'
                : 'text-salon-ink/70 hover:bg-salon-secondary/30 hover:text-salon-ink'
            }`}
          >
            <Icon size={18} strokeWidth={1.8} />
            <span>{label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default function Layout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="App min-h-screen bg-salon-bg font-sans">
      {/* Mobile top bar */}
      <div className="flex items-center justify-between border-b border-border bg-white/70 px-4 py-3 backdrop-blur-xl md:hidden">
        <div className="flex items-center gap-2">
          <img src="/medieste.png" alt="Medi Este" className="h-9 w-auto object-contain" />
        </div>
        <button
          onClick={() => setOpen(true)}
          data-testid="open-sidebar-btn"
          className="rounded-lg p-2 text-salon-ink hover:bg-salon-secondary/50"
          aria-label="Menüyü aç"
        >
          <Menu size={20} />
        </button>
      </div>

      <div className="flex">
        {/* Desktop sidebar */}
        <aside className="sticky top-0 hidden h-screen w-64 shrink-0 border-r border-border bg-white/80 backdrop-blur-xl md:flex md:flex-col">
          <Brand />
          <NavItems />
          <div className="px-6 pb-8 text-xs text-salon-muted">
            <div className="rounded-xl border border-border bg-salon-bg p-3 leading-relaxed">
              <div className="font-medium text-salon-ink">Komisyon</div>
              <div>El: %70 personel</div>
              <div>Ayak: %30 personel</div>
              <div>Kaş: %50 personel</div>
              <div>Ürün: %100 personel</div>
            </div>
          </div>
        </aside>

        {/* Mobile drawer */}
        {open && (
          <div className="fixed inset-0 z-40 md:hidden" role="dialog">
            <div className="absolute inset-0 bg-black/30" onClick={() => setOpen(false)} />
            <div className="absolute left-0 top-0 flex h-full w-72 flex-col bg-white shadow-xl">
              <div className="flex items-center justify-between px-4 pt-4">
                <div className="font-display text-lg">Menü</div>
                <button
                  onClick={() => setOpen(false)}
                  className="rounded-lg p-2 hover:bg-salon-secondary/50"
                  data-testid="close-sidebar-btn"
                  aria-label="Menüyü kapat"
                >
                  <X size={20} />
                </button>
              </div>
              <Brand />
              <NavItems onClick={() => setOpen(false)} />
            </div>
          </div>
        )}

        {/* Content */}
        <main className="min-w-0 flex-1 px-4 py-6 md:px-10 md:py-10">
          <Outlet />
        </main>
      </div>

      <Toaster position="top-right" richColors />
    </div>
  );
}
